import { ComplianceSalesActionKeys as keys } from './complianceSalesActionKeys';
import { ComplianceSalesActionTypes } from './complianceSalesActionTypes';
import { ISalesComplianceResponse } from '.';

export interface IComplianceSalesState {
  isLoading: boolean;
  response: ISalesComplianceResponse | undefined;
}

const initialState: IComplianceSalesState = {
  isLoading: false,
  response: undefined
};

export function complianceSalesReducer(
  state: IComplianceSalesState = initialState,
  action: ComplianceSalesActionTypes
): IComplianceSalesState {
  switch (action.type) {
    case keys.SET_SALES_COMPLIANCE:
      return {
        ...state,
        response: action.payload
      };
    case keys.TOGGLE_SALES_COMPLIANCE_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      };
    default:
      return state;
  }
}
